import React, { Component } from "react";
import AutoComponent from "../../common/AutoComponent";
import UniqueKey from "../../common/UniqueKey";
import { Button } from "reactstrap";



class index extends Component {
  constructor(props) {
    super(props);
  }

  
  render() {
    const currentPage = this.props.parentState.currentPage.toLowerCase();
    const currentComponents = this.props.parentState.formElements[currentPage][
      "dashboard"
    ];
    console.log("currentComponents")
    const { fileFolder } = this.props.parentState;
    return (
      <div

        className={`SearchArea  ${
          this.props.parentState.formSubmittedClass
        }`}
      >
        <div className="row col-sm-12">
          {currentComponents.map((component, index) => {
            let shouldRender = 1;
            if (shouldRender == 1) {

              return (
                <div key={index} className={`small-margin-x  ${component.widths.parent}`}>
                  <div className="boxshadow">
                  <AutoComponent
                    component={component}
                    liftState={this.props.liftState}
                    liftGlobalState={this.props.liftGlobalState}
                    parentStateGlobal={this.props.parentState}
                    parentState={this.props.parentState}
                    parentProps={this.props.parentProps}
                    key={index}
                    index={index}
                  />
                  </div>
                </div>
              );
            }
          })}
        </div>
      </div>
    );
  }
}

export default index;
